// extracted by mini-css-extract-plugin
export default {"wrapper":"Teaser_wrapper__SWJOR","wrapperIsActive":"Teaser_wrapperIsActive__LocIu","title":"Teaser_title__lEiof","icon":"Teaser_icon__o60sV"};